import React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';

function NewsListItem(props) {

  return (
    <ListItemButton>
      <Stack direction="row" spacing={2}>
        <ListItemAvatar className="muvika-news-avatar-item">
          <Avatar className="muvika-news-avatar">
            <img className="muvika-news-avatar-image" src={props.newsItem.image_url} alt="" />
          </Avatar>
        </ListItemAvatar>
        <Stack spacing={2}>
          <ListItemText className="muvika-news-title" primary={props.newsItem.subheading} secondary={props.newsItem.published} />
          <ListItemText primary={<div className="muvika-news-body" dangerouslySetInnerHTML={{ __html: props.newsItem.body }}>
          </div>} />
        </Stack>
      </Stack>
    </ListItemButton>
  );
}

export default NewsListItem;